import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import globals from '../globals'
import ServiceDetails from '../modules/ServiceDetails'
import Documents from '../modules/Documents'
import SubNavigation from '../modules/SubNavigation'
import DataSource from '../DataSource'
import DetailedUsage from '../modules/DetailedUsage'
import { SERVICE_PSTN } from '../constants'
import PstnSettings from '../modules/PstnSettings'
import AjaxLoader from '../components/AjaxLoader'
import ServiceHeading from '../modules/ServiceHeading'
import PstnInternationalRates from '../modules/PstnInternationalRates'

class PstnService extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
		    isLoaded: false,
            hasErrors: false,
            serviceId: this.props.match.params.id,
            serviceDetails: {}
        }

        this.type = SERVICE_PSTN
        this.subNav = [
            { title: 'My usage', url: '' },
            { title: 'Service details', url: '/service-details' },
            { title: 'Call & voicemail settings', url: '/settings' },
            { title: 'My documents', url: '/my-documents' },
            { title: 'International rates', url: '/international-rates' }
        ]
    }

    componentDidMount () {
        DataSource.getData(`/api/getService/${this.type}/${this.state.serviceId}`, result => {
            this.setState({
                serviceDetails: { ...result, ...result.serviceDetails },
                isLoaded: true
            })
            globals.animatePageIn(this.container)
        }, () => {
            this.setState({ isLoaded: true, hasErrors: true })
        })
    }

    render () {
        const RenderMyUsage = () => {
            return (
                <DetailedUsage
                    type={SERVICE_PSTN}
                    serviceId={this.state.serviceId}
                    serviceNo={this.state.serviceDetails.serviceNo}
                />
            )
        }

        const RenderServiceDetails = () => {
		    return (
    <ServiceDetails
                    title='My Home Phone (PSTN) service details'
                    details={this.state.serviceDetails.data}
                />
            )
        }

        const RenderDocuments = () => {
            return (
                <Documents
                    title='My documents'
                    type={this.type}
                    serviceId={this.state.serviceId}
                />
            )
        }

        const RenderPstnSettings = () => {
            return <PstnSettings serviceId={this.state.serviceId} />
        }

        if (!this.state.isLoaded) {
            return <AjaxLoader />
        }

        if (this.state.hasErrors) {
            return <Redirect push to='/' />
        }

        return (
            <div ref={el => this.container = el} style={{ opacity: 0 }}>
                <ServiceHeading
                    type={this.type}
                    icon='/images/icon-pstn.svg'
                    smallText={this.state.serviceDetails.serviceNo}
                    medText={this.state.serviceDetails.description}
                />

                <SubNavigation
                    title='Manage my service'
                    items={this.subNav}
                    url={this.props.match.url}
                    className='gtm-service-manage-tab-click'
                />

                <Switch>
                    <Route exact path={this.props.match.url} render={RenderMyUsage} />
                    <Route exact path={`${this.props.match.url}/service-details`} render={RenderServiceDetails} />
                    <Route exact path={`${this.props.match.url}/my-documents`} render={RenderDocuments} />
                    <Route exact path={`${this.props.match.url}/settings`} render={RenderPstnSettings} />
                    <Route exact path={`${this.props.match.url}/international-rates`} component={PstnInternationalRates} />
                </Switch>
            </div>
        )
    }
}

export default PstnService



// WEBPACK FOOTER //
// ./resources/js/services/PstnService.js